import { render, staticRenderFns } from "./modalAddSocialXp.vue?vue&type=template&id=95905fac&"
import script from "./modalAddSocialXp.vue?vue&type=script&lang=js&"
export * from "./modalAddSocialXp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports